export class Settings {
    constructor() {
        // Wait for DOM to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initialize());
        } else {
            this.initialize();
        }
    }

    initialize() {
        this.loadSettings();
        this.setupThemeToggle();
        this.setupSettingsPanel();
    }

    loadSettings() {
        this.apiKey = localStorage.getItem('apiKey') || '';
        this.temperature = parseFloat(localStorage.getItem('temperature')) || 1.0;
        this.systemPrompt = localStorage.getItem('systemPrompt') || 'You are a helpful assistant.';
        this.theme = localStorage.getItem('theme') || 'light';

        // Apply saved settings to UI
        document.getElementById('apiKey').value = this.apiKey;
        document.getElementById('temperature').value = this.temperature;
        document.getElementById('temperatureValue').textContent = this.temperature;
        document.getElementById('systemPrompt').value = this.systemPrompt;
        document.documentElement.setAttribute('data-theme', this.theme);
    }

    setupThemeToggle() {
        const themeToggle = document.getElementById('themeToggle');
        const themeIcon = themeToggle.querySelector('i');

        themeToggle.addEventListener('click', () => {
            const newTheme = this.theme === 'light' ? 'dark' : 'light';
            this.theme = newTheme;
            document.documentElement.setAttribute('data-theme', newTheme);
            themeIcon.className = `ri-${newTheme === 'light' ? 'sun' : 'moon'}-line`;
            localStorage.setItem('theme', newTheme);
        });
    }

    setupSettingsPanel() {
        const settingsBtn = document.querySelector('#settingsBtn');
        const settingsPanel = document.querySelector('#settingsPanel');
        const settingsClose = document.querySelector('#settingsClose');
        const closeIcon = document.querySelector('#settingsClose i');
        const settingsOverlay = document.querySelector('#settingsOverlay');

        // Basic close function
        function closePanel() {
            settingsPanel.classList.add('hidden');
            settingsOverlay.classList.add('hidden');
        }

        // Basic open function
        function openPanel() {
            settingsPanel.classList.remove('hidden');
            settingsOverlay.classList.remove('hidden');
        }

        // Settings button opens panel
        settingsBtn.addEventListener('click', openPanel);

        // Close button AND its icon both close panel
        settingsClose.addEventListener('click', closePanel, true);
        closeIcon.addEventListener('click', closePanel, true);

        // Overlay closes panel
        settingsOverlay.addEventListener('click', closePanel);

        // Escape key closes panel
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closePanel();
        });

        // Settings changes
        const temperatureInput = document.querySelector('#temperature');
        const temperatureValue = document.querySelector('#temperatureValue');
        const apiKeyInput = document.querySelector('#apiKey');
        const systemPromptInput = document.querySelector('#systemPrompt');

        temperatureInput.addEventListener('input', (e) => {
            const value = parseFloat(e.target.value);
            temperatureValue.textContent = value.toFixed(1);
            this.temperature = value;
            localStorage.setItem('temperature', value);
        });

        apiKeyInput.addEventListener('change', (e) => {
            this.apiKey = e.target.value;
            localStorage.setItem('apiKey', e.target.value);
        });

        systemPromptInput.addEventListener('change', (e) => {
            this.systemPrompt = e.target.value;
            localStorage.setItem('systemPrompt', e.target.value);
        });
    }

    getSettings() {
        return {
            apiKey: this.apiKey,
            temperature: this.temperature,
            systemPrompt: this.systemPrompt
        };
    }
}
